
export enum CustomerProfileDetailCd {
	NOTE = 'Note',
	PROFILE = 'Profile',
	SCHEDULE = 'Schedule'}

